export enum SportsFieldView {
  LIST = 1,
  DETAIL = 2,
  SCHEDULE = 3,
  EDIT = 4,
  EDIT_FIELD = 5,
  EDIT_REQUEST_LIST = 6,
  EDIT_REQUEST_NEW = 7,
  EDIT_REQUEST_DETAIL = 8,
  ADD = 9,
  LIST_EXPORT = 10,
  DELETE = 11,
}
